import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Dil dosyalarını import et
import tr from './locales/tr.json';
import en from './locales/en.json';
import ru from './locales/ru.json';

const resources = {
  tr: {
    translation: tr
  },
  en: {
    translation: en
  },
  ru: {
    translation: ru
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'tr', // Varsayılan dil Türkçe
    debug: process.env.NODE_ENV === 'development',

    interpolation: {
      escapeValue: false, // React zaten XSS koruması yapıyor
    },

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
  });

export default i18n;
